import heroBackground from '@/assets/images/almadata-bg.jpg';
import logoImage from '@/assets/images/logo.png';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function HeroSection() {
  const { ref, visible } = useScrollAnimation(0.05);

  const handleScroll = (href: string) => {
    document.getElementById(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroBackground}
          alt="Almadata Hero Background"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(16,185,129,0.18),transparent_28%),radial-gradient(circle_at_80%_18%,rgba(45,212,191,0.14),transparent_24%),radial-gradient(circle_at_center,rgba(16,185,129,0.10),transparent_55%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/75" />
      </div>

      {/* Animated orbs */}
      <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl animate-pulse-slow pointer-events-none" />
      <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse-slow pointer-events-none" style={{ animationDelay: '1.5s' }} />

      {/* Content */}
      <div ref={ref} className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-8 text-center py-24">
        {/* Logo + brand */}
        <div className={`flex items-center justify-center gap-4 mb-8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <img
            src={logoImage}
            alt="Almadata"
            className="h-16 md:h-20 w-auto animate-float"
          />
        </div>

        {/* Headline */}
        <h1 className={`font-sora font-bold text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 transition-all duration-700 delay-150 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          alma<span className="text-emerald-400">data</span>
        </h1>

        <p className={`font-sora text-lg md:text-2xl text-white/80 font-light mb-5 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          Estratégia de Negócio. Engenharia de Software. <span className="text-emerald-400 font-medium">Inteligência Artificial.</span>
        </p>

        <p className={`font-inter text-base md:text-lg text-white/60 max-w-2xl mx-auto mb-10 transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          Entendemos o seu modelo de negócio, identificamos onde a tecnologia gera retorno real e implementamos soluções com rigor técnico e inteligência artificial — do diagnóstico ao resultado mensurável.
        </p>

        {/* CTAs */}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 mb-14 transition-all duration-700 delay-400 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <button
            onClick={() => handleScroll('services')}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-full font-semibold font-sora text-base transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Conheça Nossos Serviços
          </button>
          <button
            onClick={() => handleScroll('contact')}
            className="border border-white/40 hover:border-emerald-400 hover:text-emerald-400 text-white px-8 py-4 rounded-full font-semibold font-sora text-base transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Fale Conosco
          </button>
        </div>


      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-float cursor-pointer" onClick={() => handleScroll('about')}>
        <span className="text-white/40 text-xs font-inter tracking-widest uppercase">Explore</span>
        <i className="ri-arrow-down-line text-white/50 text-xl" />
      </div>
    </section>
  );
}
